import { useSyncExternalStore } from 'react';

const DEFAULT_BOXES_VISIBLE = process.env.REACT_APP_APP_VARIANT === 'citizen-science';
// Keep the in-app choice separate from the website's existing preference,
// including a hidden-box value saved by an earlier pilot build.
const STORAGE_KEY = DEFAULT_BOXES_VISIBLE
  ? 'latest-sightings:citizen-science:motion-show-boxes:v1'
  : 'ting-vision:motion-show-boxes:v1';
const CHANGE_EVENT = 'ting-vision:motion-show-boxes-changed';
let inMemoryPreference = DEFAULT_BOXES_VISIBLE;
let storageUnavailable = false;

function readPreference() {
  if (storageUnavailable) return inMemoryPreference;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'true' || stored === 'false' ? stored === 'true' : DEFAULT_BOXES_VISIBLE;
  }
  catch (_) { return inMemoryPreference; }
}

function subscribe(listener) {
  const storageChanged = (event) => {
    if (event.key === STORAGE_KEY || event.key === null) listener();
  };
  window.addEventListener('storage', storageChanged);
  window.addEventListener(CHANGE_EVENT, listener);
  return () => {
    window.removeEventListener('storage', storageChanged);
    window.removeEventListener(CHANGE_EVENT, listener);
  };
}

function setBoxesVisible(value) {
  inMemoryPreference = Boolean(value);
  try { window.localStorage.setItem(STORAGE_KEY, String(inMemoryPreference)); }
  catch (_) { storageUnavailable = true; }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export default function useMotionBoxPreference() {
  const boxesVisible = useSyncExternalStore(subscribe, readPreference, () => DEFAULT_BOXES_VISIBLE);
  return [boxesVisible, setBoxesVisible];
}
